function setDatesRanges() {
    const options = {
        timeZone: "Europe/Berlin"
    }
    const now = new Date();
    const currentHour = (new Intl.DateTimeFormat([], { ...options, hour: '2-digit', hour12: false }).format(now)).split(" ").at(0)

    let shippingDay = now;

    if (+currentHour >= 12) {
        shippingDay.setDate(shippingDay.getDate() + 1)
    }

    setNextWorkingDay(shippingDay)

    const formatter = new Intl.DateTimeFormat("de-DE", { ...options, day: "numeric", month: "long" })

    let shippedAt = ""
    shippedAt += formatter.format(shippingDay)

    let deliveredAt = ""

    shippingDay.setDate(shippingDay.getDate() + 2)
    setNextWorkingDay(shippingDay)

    const weekdayFormat = new Intl.DateTimeFormat("de-DE", { ...options, weekday: "long"})

    deliveredAt += formatter.format(shippingDay)

    const closestDelivery = document.querySelector("#closest-delivery")
    closestDelivery.textContent = weekdayFormat.format(shippingDay) + ", " + formatter.format(shippingDay)

    deliveredAt += " -\n "

    shippingDay.setDate(shippingDay.getDate() + 2)
    setNextWorkingDay(shippingDay)
    deliveredAt += formatter.format(shippingDay)

    const ship = document.querySelector("#shippedAt")
    ship.textContent = shippedAt

    const deli = document.querySelector("#deliveredAt")
    deli.textContent = deliveredAt
    updateTimeLeft()

    setInterval(updateTimeLeft, 1000 * 60)
}

function updateTimeLeft() {
    const currentHour = new Intl.DateTimeFormat([], { timeZone: "Europe/Berlin", hour: '2-digit', hour12: false }).format(new Date()).split(" ").at(0)
    let time = ""
    if (currentHour < 12) {
        time = 12 - currentHour
    } else {
        time = 24 - (currentHour - 12)
        const currentDay = (new Date()).getDay()
        if (currentDay == 5) {
            time += 48;
        } else if (currentDay == 6) {
            time += 24;
        }
    }
    const left = document.querySelector("#timeLeft")

    if (time == 1) {
        const currentMinute = new Intl.DateTimeFormat([], { timeZone: "Europe/Berlin", minute: '2-digit', hour12: false }).format(new Date())

        time = currentMinute;

        if (currentMinute == 1) {
            time += " Minute"
        } else {
            time += " Minuten"
        }
    } else {
        time += " Stunden"
    }
    left.textContent = time
}


/** @param {Date} date  */
function setNextWorkingDay(date) {
    if (date.getDay() === 6) {
        date.setDate(date.getDate() + 2)
    } else if (date.getDay() === 0) {
        date.setDate(date.getDate() + 1)
    }
}

setDatesRanges()
